var InputBase = require('../base');

var Select = InputBase.extend( {
    /*
    @inputOption = {
        options: 'val1:name1;val2:name;val3:name3',
        nullOpText: 'Please select',
    }
    */
    create: function( inputOptions, $container ) {
        var $inp = $( '<select class="ui-widget-content"></select>' );
        if ( inputOptions.nullOpText ) {
            $inp.append( '<option value="">' + inputOptions.nullOpText + '</option>' );
        }
        inputOptions.options = (inputOptions.options || '').replace(/;$/, '');
        var options = inputOptions.options ? inputOptions.options.split( ';' ) : [], opt;
        for ( var i = 0; i < options.length; i++ ) {
            opt = options[ i ];
            $('<option>').attr( 'value', opt.split( ':' )[ 1 ] )
                .text( opt.split( ':' )[ 0 ] )
                .appendTo( $inp );
        }
        var self = this;
        $inp.bind( 'change', function() {
            self.trig( 'Change' );
        } );
        $container.append( $inp );
        $inp.selectmenu({
            change: function( event, ui ) {
                self.check();
                self.trig( 'Change' );
            },
            focus: function( event, ui ) {
                 self.trig( 'Focus' );
            },
            select: function( event, ui ) {
                self.trig( 'Select' );
            } 
        });
        return $inp;
    },
    bindCheckEvent: function( eventName ) {
        // if ( eventName === 'default' ) {
        //     eventName = 'change';
        // }
        // var self = this;
        // this.$inp.bind( eventName, function() {
        //     self.check();
        // } );
    },
    bindData: function( data ) {
        if (!data) {
            return;
        }
        var that = this;
        this.$inp.html( '' );
        for( var i = 0; i < data.length; i++ ) {
            this.$inp.append( '<option value="' 
                + data[ i ].value + '">' + data[ i ].displayName + '</option>' );
        }
        this.$inp.selectmenu('destroy').selectmenu( {
            change: function( event, ui ) {
                that.check();
                that.trig( 'Change' );
            },
            focus: function( event, ui ) {
                that.trig( 'Focus' );
            },
            select: function( event, ui ) {
                that.trig( 'Select' );
            } 
        } );
    },
    getValue: function() {
        return this.$inp.val();
    },
    setValue: function( val ) {
        var that = this;
        // Make sure the options contains this val, else return directly.
        if (!this.$inp.find('option[value=' + val + ']').length) {
            return;
        }
        this.$inp.val( val );

        this.$inp.selectmenu( 'refresh' );
        return this;
    },
    getDisplayName: function() {
        return this.$inp.find('option:selected').text();
    }
} );

module.exports = Select;


//////////////////
// WEBPACK FOOTER
// ./src/input-factory/select/index.js
// module id = 16
// module chunks = 0